import * as yup from 'yup';
import { IPatientPurchase } from '../../../library/models/patientPurchase';
import { integerIn, NumericBounds, TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/**
 * How many of a purchase's sessions can have been used before Carefull: whatever is not
 * held here or booked. The server refuses the same, with the same arithmetic -- this only
 * says so before the press rather than after.
 */
export const sessionsUsedBeforeBounds = (purchase: IPatientPurchase): NumericBounds => ({
    min: 0,
    max: Math.max(
        purchase.sessionsUsedBefore + purchase.remainingSessions - purchase.scheduledSessions,
        0
    ),
});

export const createAdjustSessionsUsedBeforeSchema = (
    translate: TranslateFn,
    bounds: NumericBounds
) => yup.object({
    sessionsUsedBefore: integerIn(
        bounds, translate, ResourcesIds.PURCHASE_USED_BEFORE_RANGE, { required: true }),
});

export interface AdjustSessionsUsedBeforeFormValues {
    /** A string while it is being typed; see `integerIn`. */
    sessionsUsedBefore: string;
}
